// extracted by mini-css-extract-plugin
export default {"banner":"HomeBanner_banner__9iOoC"};